var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-generator',{key:"form-generator-prop-designer",attrs:{"schema":_vm.schema,"readonly":_vm.readonly,"cancel":_vm.cancel,"submit-title":_vm.submitTitle,"submit-loader":_vm.submitLoader},on:{"submit":_vm.onSubmit,"cancel":_vm.onCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }